// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__18YVg","rightAdornment":"Header_rightAdornment__21Nwc"};